import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import { Link } from '@unisporkal/alliance-ui';
import { useSiteMap } from '@unisporkal/sites';
import { ga4Track, ctaInteraction } from '@unisporkal/ga4';
import LinkNewWindowIcon from '../../../icons/LinkNewWindow.svg?icon';
import { useAsset } from '../../../hooks/stateful/useAsset';
import styles from './MarketFreeze.module.scss';

const MarketFreeze = () => {
  const t = useTranslations();
  const siteMap = useSiteMap();
  const { asset } = useAsset();
  const marketFreezeLink = siteMap.eloquaMarketFreezeContactUsUrl(asset.id);

  const handleLinkClick = () => {
    const ga4Event = ctaInteraction({
      cta_selection: 'market_freeze',
      cta_text: 'market_freeze',
      cta_url: marketFreezeLink,
      ui_element_location: 'adp_size_buy_card',
    });

    ga4Track(ga4Event);
  };

  return (
    <div>
      <Link
        data-testid="market-freeze-link"
        href={marketFreezeLink}
        className={styles.titleRow}
        onClick={handleLinkClick}
        target="_blank"
      >
        <div className={styles.title}>{t('rf_market_freeze')}</div>
        <LinkNewWindowIcon />
      </Link>
      <div className={styles.description}>{t('we_will_remove_this_image')}</div>
    </div>
  );
};

export default MarketFreeze;
